import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 300 300.002"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#3b5998",
      d: "M282.553 299.002c9.082 0 16.447-7.365 16.447-16.447V17.448C299 8.363 291.635 1 282.553 1H17.447C8.36 1 1 8.363 1 17.448v265.107c0 9.082 7.361 16.447 16.447 16.447h265.106Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#FFF",
      d: "M206.615 299.002V183.601h38.736l5.8-44.975h-44.536v-28.714c0-13.021 3.615-21.895 22.288-21.895l23.816-.01V47.78c-4.12-.547-18.257-1.772-34.703-1.772-34.338 0-57.844 20.96-57.844 59.45v33.167h-38.835v44.975h38.835v115.401h46.443Z"
    }, null, -1)
  ])))
}
export default { render: render }